(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hilite-gear-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const evenlySpacedRatios = (gears, firstRatio, overallRange) => Array.from(
      { length: gears },
      (_, index) => firstRatio * Math.pow(overallRange, index / (gears - 1))
    );
    const PINION = {
      pinion18: evenlySpacedRatios(18, 1/1.82, 6.36),
      pinion12: evenlySpacedRatios(12, 1/1.82, 6.00),
      pinion9: evenlySpacedRatios(9, 1/1.82, 5.68),
      pinion6: evenlySpacedRatios(6, 1/0.95, 2.95)
    };
    const ROHLOFF = [0.279, 0.316, 0.360, 0.409, 0.464, 0.528, 0.600, 0.682, 0.774, 0.881, 1.000, 1.135, 1.292, 1.467];
    const PRESETS = {
      chain_sram_10_52: { front: '32', rear: '10, 12, 14, 16, 18, 21, 24, 28, 32, 36, 42, 52' },
      chain_sram_10_50: { front: '32', rear: '10, 12, 14, 16, 18, 21, 24, 28, 32, 36, 42, 50' },
      chain_shimano_10_51: { front: '32', rear: '10, 12, 14, 16, 18, 21, 24, 28, 33, 39, 45, 51' },
      chain_3x9: { front: '26, 36, 48', rear: '11, 13, 15, 17, 20, 23, 26, 30, 34' }
    };

    const numbers = (value) => value.split(',').map((item) => Number.parseFloat(item.trim())).filter((item) => Number.isFinite(item) && item > 0);
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    document.querySelectorAll('[data-gear-calculator]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const field = (name) => root.querySelector(`[data-field="${name}"]`);
      const system = field('system');
      const chainFields = root.querySelector('[data-fields="chain"]');
      const gearboxFields = root.querySelector('[data-fields="gearbox"]');
      const warning = root.querySelector('[data-ratio-warning]');

      const updateSystem = () => {
        const isChain = system.value.startsWith('chain');
        chainFields.hidden = !isChain;
        gearboxFields.hidden = isChain;
        if (PRESETS[system.value]) {
          field('chainrings').value = PRESETS[system.value].front;
          field('cogs').value = PRESETS[system.value].rear;
        }
        if (system.value === 'rohloff') {
          field('front').value = '42';
          field('rear').value = '19';
        } else if (system.value.startsWith('pinion')) {
          field('front').value = '30';
          field('rear').value = '30';
        }
      };

      const buildGears = () => {
        const circumference = clamp(Number.parseFloat(field('circumference').value) || 2220, 500, 4000) / 1000;
        const cadence = clamp(Number.parseFloat(field('cadence').value) || 80, 20, 200);
        const gears = [];
        if (system.value.startsWith('chain')) {
          const chainrings = numbers(field('chainrings').value);
          const cogs = numbers(field('cogs').value);
          chainrings.forEach((chainring, row) => {
            cogs.forEach((cog) => {
              const ratio = chainring / cog;
              const development = ratio * circumference;
              gears.push({ name: `${chainring}T / ${cog}T`, ratio, development, speed: development * cadence * 0.06, row });
            });
          });
        } else {
          const front = clamp(Number.parseFloat(field('front').value) || 1, 1, 200);
          const rear = clamp(Number.parseFloat(field('rear').value) || 1, 1, 200);
          const primary = front / rear;
          const internal = system.value === 'rohloff' ? ROHLOFF : (PINION[system.value] || []);
          internal.forEach((internalRatio, index) => {
            const ratio = primary * internalRatio;
            const development = ratio * circumference;
            gears.push({ name: `${root.dataset.gearLabel} ${index + 1}`, ratio, development, speed: development * cadence * 0.06, row: 0 });
          });
          warning.hidden = false;
          warning.textContent = root.dataset.ratioWarning;
        }
        if (system.value.startsWith('chain')) warning.hidden = true;
        gears.sort((a, b) => a.development - b.development);
        return { gears, cadence };
      };

      const render = () => {
        const { gears, cadence } = buildGears();
        root.querySelector('[data-cadence-label]').textContent = String(cadence);
        const tbody = root.querySelector('[data-results-table]');
        const ticks = root.querySelector('[data-chart-ticks]');
        const rows = root.querySelector('[data-chart-rows]');
        tbody.replaceChildren();
        ticks.replaceChildren();
        rows.replaceChildren();
        if (!gears.length) {
          root.querySelector('[data-result="development"]').textContent = root.dataset.emptyMessage;
          root.querySelector('[data-result="speed"]').textContent = '–';
          root.querySelector('[data-result="range"]').textContent = '–';
          return;
        }
        const first = gears[0];
        const last = gears[gears.length - 1];
        root.querySelector('[data-result="development"]').textContent = `${first.development.toFixed(2)}–${last.development.toFixed(2)} m`;
        root.querySelector('[data-result="speed"]').textContent = `${first.speed.toFixed(1)}–${last.speed.toFixed(1)} km/h`;
        root.querySelector('[data-result="range"]').textContent = `${Math.round((last.development / first.development) * 100)}%`;

        gears.forEach((gear) => {
          const tr = document.createElement('tr');
          [gear.name, gear.ratio.toFixed(2), `${gear.development.toFixed(2)} m`, `${gear.speed.toFixed(1)} km/h`].forEach((value) => {
            const td = document.createElement('td');
            td.textContent = value;
            tr.appendChild(td);
          });
          tbody.appendChild(tr);
        });

        const max = Math.max(1, Math.ceil(last.development));
        const tickCount = 6;
        for (let index = 0; index < tickCount; index += 1) {
          const tick = document.createElement('span');
          tick.textContent = `${(max * index / (tickCount - 1)).toFixed(1)} m`;
          ticks.appendChild(tick);
        }
        gears.forEach((gear) => {
          const row = document.createElement('div');
          row.className = 'hilite-gear__bar-row';
          row.dataset.row = String(gear.row);
          const label = document.createElement('span');
          label.className = 'hilite-gear__bar-label';
          label.textContent = gear.name;
          label.title = gear.name;
          const track = document.createElement('div');
          track.className = 'hilite-gear__bar-track';
          const bar = document.createElement('div');
          bar.className = 'hilite-gear__bar';
          bar.style.width = `${Math.max(8, (gear.development / max) * 100)}%`;
          bar.setAttribute('role', 'img');
          bar.setAttribute('aria-label', `${gear.name}: ${gear.development.toFixed(2)} m, ${gear.speed.toFixed(1)} km/h`);
          const development = document.createElement('span');
          development.textContent = `${gear.development.toFixed(2)} m`;
          const speed = document.createElement('span');
          speed.className = 'hilite-gear__bar-detail';
          speed.textContent = `${gear.speed.toFixed(1)} km/h`;
          bar.append(development, speed);
          track.appendChild(bar);
          row.append(label, track);
          rows.appendChild(row);
        });
      };

      system.addEventListener('change', () => { updateSystem(); render(); });
      field('wheel-preset').addEventListener('change', () => {
        if (field('wheel-preset').value !== 'custom') field('circumference').value = field('wheel-preset').value;
        render();
      });
      root.querySelectorAll('input').forEach((input) => input.addEventListener('input', render));
      updateSystem();
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
